<template>
	<div class="index_div">
		<h1>商户搜索管理系统</h1>
		<div>
			<el-button type="primary" @click="goPage('/HouseInsert')">新增商户</el-button>
			<el-button type="success" @click="goPage('/HouseView')">地图搜店</el-button>
		</div>

	</div>

</template>

<script>
	export default{
		methods: {
			goPage(url){
				this.$router.push(url);
			}
		}
	}
</script>

<style>
	.index_div{
		display: flex;
		flex-direction: column;	/* 纵向排列 */
		justify-content: space-evenly;	/* 主轴均等分 */
		align-items: center;	/* 交叉轴居中 */
	}
</style>
